import React from 'react'
import { rem } from 'polished'
import Heading from 'components/Luxkit/Typography/Heading'
import OfferCarouselHeader from 'home/components/OfferCarousels/common/OfferCarouselHeader'
import { MAX_CAROUSEL_ITEM_COUNT } from 'home/components/OfferCarousels/common/constants'
import OfferCarouselLookingForSomethingElse from 'home/components/LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from 'home/components/LookingForSomethingElse/constants'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

const SectionContainer = styled(VerticalSpacer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const OFFER_TYPES: Array<App.OfferListOfferType> = ['hotel', 'tactical_ao_hotel', 'last_minute_hotel']
const DEFAULT_FILTERS = {
  offerTypes: OFFER_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

function VelocityOfferCarousel() {
  return (
    <SectionContainer gap={20}>
      <LayoutContainer>
        <VerticalSpacer gap={20}>
          <OfferCarouselHeader
            allTo="/hotels"
          >
            <Heading variant="heading3">
              Use Velocity Points on these top offers
            </Heading>
          </OfferCarouselHeader>
        </VerticalSpacer>
      </LayoutContainer>
      <OfferListCarousel filters={DEFAULT_FILTERS}>
        <OfferCarouselLookingForSomethingElse to={LOOKING_FOR_SOMETHING_ELSE_CONTENT.hotels.to} />
      </OfferListCarousel>
    </SectionContainer>
  )
}

export default VelocityOfferCarousel
